import React from 'react';
import Vehicle from '../assets/images/VehicleIcon.svg';

export default () => {
  return <img src={Vehicle} alt="" />;
};
